import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'
import * as channelsApi from '@/network/api/channels.api.js'

/** requests transfers list
@return { promise }
*/
export const requestTransfersList = async (context, payload) => {
	const res = await transfersApi.getTransfersList(payload)

	if (res) context.commit('SAVE_TRANSFERS_LIST', { pageNumber: payload.pageNumber, data: res.data.data })
	return res
}

/** requests operations status list
@return { promise } - Status list request
*/
export const requestTransfersStatusList = async (context, payload) => {
    const res = await operationsApi.getOperationsStatusList()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFERS_STATUS_LIST', data)
    }
    return res
}

/** requests channels list
@return { promise } - Channels list request
*/
export const requestChannelsList = async (context, payload) => {
    const res = await channelsApi.getChannelsList()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CHANNELS_LIST', data)
    }
    return res
}

/** requests operation details
@return { promise } - Operation details request
*/
export const requestOperationDetails = async (context, payload) => {
    const res = await operationsApi.getOperationGenericDetail(payload)

    if (res) context.commit('SAVE_OPERATION_DETAILS', res.data.data)
    return res
}

/** updates operation favorite status */
export const updateFavoriteStatus = async (context, payload) => {
    context.commit('UPDATE_FAVORITE_STATUS', payload)
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
